// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__2_3vs","messages":"Chat_messages__2tlHq","dateDivider":"Chat_dateDivider__FMloW"};